import { GetterTree } from 'vuex';
import { ContractModel } from '@descomplica/dex-models';
import { ContractState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<ContractState, RootState> = {
  contractById: (state, contractsGetters) => (contractId: number) => {
    const contract = state.contracts[contractId.toString()];
    return contract ? new ContractModel(contract, contractsGetters) : undefined;
  },
  contractByCourseId:
    (state, contractsGetters) =>
    (courseId: number): ContractModel | null => {
      const contract = Object.values(state.contracts).find((c) => c.courseByCourseId === courseId);

      return contract ? new ContractModel(contract, contractsGetters) : null;
    },
};

export default getters;
